import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import {
  getOrderFormPaymentsSelector,
  getOrderFormRemoveGiftOptionLoadingSelector,
  getOutstandingBalanceSelector,
} from '../../redux/reducers/order-form/orderFormSelector';
import {
  getGiftVoucherApplyGiftPaymentFailedSelector,
  getGiftVoucherErrorMessageSelector,
  getGiftVoucherFormSubmitFailedSelector,
  getGiftVoucherIsLoadingSelector,
} from '../../redux/reducers/payment/giftVoucherSelector';
import { isZeroAmount } from '../../utils';
import { APPLY_GIFT_VOUCHER_FORM_ID } from '../../utils/form/configs/giftOptions';

const fieldValueSelector = (state: RootState) => state.form?.[APPLY_GIFT_VOUCHER_FORM_ID]?.values;

const applyGiftVoucherState = createSelector(
  [
    getGiftVoucherApplyGiftPaymentFailedSelector,
    getGiftVoucherErrorMessageSelector,
    getGiftVoucherFormSubmitFailedSelector,
    getOrderFormPaymentsSelector,
    getGiftVoucherIsLoadingSelector,
    getOutstandingBalanceSelector,
    getOrderFormRemoveGiftOptionLoadingSelector,
    fieldValueSelector,
  ],
  (
    applyGiftPaymentFailed,
    errorMessage,
    formSubmitFailed,
    payments,
    isLoading,
    outstandingBalance,
    removeGiftOptionLoading,
    values,
  ) => ({
    applyGiftPaymentFailed,
    errorMessage,
    formSubmitFailed,
    payments,
    isGiftVoucherAmountZero: isZeroAmount(outstandingBalance ?? ''),
    isLoading,
    outstandingBalance,
    removeGiftOptionLoading,
    values,
  }),
);

export default applyGiftVoucherState;
